import React from "react";
import styled from "styled-components";

const GlobalWrapper = styled.div``;

export default props => {
  const { children } = props;
  return <GlobalWrapper>{children}</GlobalWrapper>;
};
